import { Channel } from '@at/consumer-web-types';
const DEFAULT_FINANCE_TERM = '48';
const DEFAULT_FINANCE_MILEAGE = '10000';
const DEFAULT_FINANCE_DEPOSIT = '1000';
const CARS_DEFAULT_FINANCE_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE = '10%';
const VANS_DEFAULT_FINANCE_DEPOSIT = '5000';
const BIKES_DEFAULT_FINANCE_MILEAGE = '6000';
export const CARS_DEFAULT_FINANCE = '10000_1000_48';
export const CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE = '10000_10%_48';
export const VANS_PAST_DEFAULT_FINANCE = '10000_3000_48';
export const VANS_DEFAULT_FINANCE = '10000_5000_48';
export const BIKES_DEFAULT_FINANCE = '6000_1000_48';
export const CARS_DEFAULT_FINANCE_STRING = '48 month term, £1,000 deposit and 10,000 miles/year';
export const CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE_STRING = '48 month term, 10% deposit and 10,000 miles/year';
export const VANS_PAST_DEFAULT_FINANCE_STRING = '48 month term, £3,000 deposit and 10,000 miles/year';
export const VANS_DEFAULT_FINANCE_STRING = '48 month term, £5,000 deposit and 10,000 miles/year';
export const BIKES_DEFAULT_FINANCE_STRING = '48 month term, £1,000 deposit and 6,000 miles/year';
export const getDefaultFinanceOptions = (channel, displayFinanceDepositAsPercentageOfVehicleValue) => {
    switch (channel) {
        case Channel.vans:
            return {
                value: VANS_DEFAULT_FINANCE,
                string: VANS_DEFAULT_FINANCE_STRING,
                term: DEFAULT_FINANCE_TERM,
                mileage: DEFAULT_FINANCE_MILEAGE,
                deposit: VANS_DEFAULT_FINANCE_DEPOSIT,
            };
        case Channel.bikes:
            return {
                value: BIKES_DEFAULT_FINANCE,
                string: BIKES_DEFAULT_FINANCE_STRING,
                term: DEFAULT_FINANCE_TERM,
                mileage: BIKES_DEFAULT_FINANCE_MILEAGE,
                deposit: DEFAULT_FINANCE_DEPOSIT,
            };
        default:
            if (displayFinanceDepositAsPercentageOfVehicleValue) {
                return {
                    value: CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE,
                    string: CARS_DEFAULT_FINANCE_WITH_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE_STRING,
                    term: DEFAULT_FINANCE_TERM,
                    mileage: DEFAULT_FINANCE_MILEAGE,
                    deposit: CARS_DEFAULT_FINANCE_DEPOSIT_AS_PERCENTAGE_OF_VEHICLE_VALUE,
                };
            }
            return {
                value: CARS_DEFAULT_FINANCE,
                string: CARS_DEFAULT_FINANCE_STRING,
                term: DEFAULT_FINANCE_TERM,
                mileage: DEFAULT_FINANCE_MILEAGE,
                deposit: DEFAULT_FINANCE_DEPOSIT,
            };
    }
};
/**
 * Decodes a finance option string (e.g. "10000_1000_48" => { mileage: "10000", deposit: "1000", term: "48" }).
 *
 * @param option - The finance option string to decode.
 * @returns An object containing mileage, deposit, and term as strings.
 *
 * @remarks
 * This function was moved from the package "@at/sauron-search-form-builder" to "@at/finance-utils"
 * for better code organisation and maintainability.
 */
export const decodeFinanceOption = (option) => {
    const financeValue = option.split('_');
    return {
        mileage: financeValue[0],
        deposit: financeValue[1],
        term: financeValue[2],
    };
};
/**
 * Encodes a finance option object into a string (e.g. { mileage: "10000", deposit: "1000", term: "48" } => "10000_1000_48").
 *
 * @param options - An object containing mileage, deposit, and term as strings.
 * @returns A string representing the finance option.
 *
 * @remarks
 * This function was moved from the package "@at/sauron-search-form-builder" to "@at/finance-utils"
 * for better code organisation and maintainability.
 */
export const encodeFinanceOption = (options) => {
    return `${options.mileage}_${options.deposit}_${options.term}`;
};
